import { useEffect, useState } from 'react';

const EMPTY = {
  nombre: '',
  descripcion: '',
  tipo: '',
  ruta: '',
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        nombre: data.nombre ?? '',
        descripcion: data.descripcion ?? '',
        tipo: data.tipo ?? '',
        ruta: data.ruta ?? '',
      });
    } else {
      setForm(EMPTY);
    }
  }, [mode, data]);

  if (!open) return null;

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo recurso' : 'Editar recurso'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '15%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>
      {/* Nombre */}
      <div style={{ gridColumn: '1 / -1' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Nombre del recurso:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.nombre}
          onChange={(e) => setForm({ ...form, nombre: e.target.value })}
          maxLength={150}
        />
      </div>

      {/* Descripción */}
      <div style={{ gridColumn: '1 / -1' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Descripción:</label>
        <br /><br />
        <textarea
          className="infoField"
          style={{ minHeight: 100, resize: 'vertical' }}
          value={form.descripcion}
          onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
          maxLength={500}
        />
      </div>

      {/* Tipo */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.tipo}
          onChange={(e) => setForm({ ...form, tipo: e.target.value })}
          maxLength={100}
          placeholder="p.ej. 'Página', 'Acción', 'Vista'"
        />
      </div>

      {/* Ruta */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Ruta:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.ruta}
          onChange={(e) => setForm({ ...form, ruta: e.target.value })}
          maxLength={300}
          placeholder="../Seguridad/Components/Roles/RolesCatalog.jsx"
        />
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="btn-cancel" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => onSubmit(form, mode)}
        disabled={!form.nombre?.trim()}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(720px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
